var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_136687",
    "data-name": "Group 136687",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60.591,
    height: 60.589,
    viewBox: "0 0 60.591 60.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.593,
    y1: 1,
    x2: 0.595,
    y2: 0.026,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_110798",
    "data-name": "Path 110798",
    d: "M105.57,21.388H93.463v1.065A12.157,12.157,0,0,0,105.57,33.516v.043H111.6V21.388Z",
    transform: "translate(-93.463 8.907)",
    fill: "#cbcbcb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110799",
    "data-name": "Path 110799",
    d: "M128,25.365h12.171A12.166,12.166,0,0,0,128,13.2h-5.954v12.16Z",
    transform: "translate(-79.577 4.93)",
    fill: "#cbcbcb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110800",
    "data-name": "Path 110800",
    d: "M113.852,35.6h.043A12.147,12.147,0,0,0,124.946,47.7h1.065l.012-18.123H113.852Z",
    transform: "translate(-83.557 12.886)",
    fill: "#e0e0e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110801",
    "data-name": "Path 110801",
    d: "M117.828,13.16A12.164,12.164,0,0,0,105.668,1V19.135h12.16V13.16Z",
    transform: "translate(-87.533 -1)",
    fill: "#e0e0e0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110802",
    "data-name": "Path 110802",
    d: "M105.668,21.388V39.575h.031a12.156,12.156,0,0,0,11.052,12.107h1.077V21.388Z",
    transform: "translate(-87.532 8.907)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110803",
    "data-name": "Path 110803",
    d: "M131.976,21.388H113.852V33.559h30.3a12.168,12.168,0,0,0-12.171-12.171",
    transform: "translate(-83.557 8.907)",
    fill: "#cbcbcb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110804",
    "data-name": "Path 110804",
    d: "M113.852,1V31.294h12.171V13.16A12.166,12.166,0,0,0,113.852,1",
    transform: "translate(-83.557 -1)",
    fill: "#e0e0e0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_110805",
    "data-name": "Path 110805",
    d: "M93.464,13.2v1.067a12.157,12.157,0,0,0,12.107,11.061v.033h18.187V13.2H93.464Z",
    transform: "translate(-93.462 4.93)",
    fill: "#cbcbcb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25585",
    "data-name": "Rectangle 25585",
    width: 12.171,
    height: 11.107,
    transform: "translate(30.295 19.188)",
    fill: "#e0e0e0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25587",
    "data-name": "Rectangle 25587",
    width: 12.171,
    height: 11.649,
    transform: "translate(18.646 30.294) rotate(-90)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25588",
    "data-name": "Rectangle 25588",
    width: 12.171,
    height: 11.649,
    transform: "translate(30.294 41.943) rotate(180)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.3d951fd67d7d27894e59969596242b59.svg";
export { ForwardRef as ReactComponent };